<template>
  <div class="change-order-scope-items">
    <scope-items-list :items="scopeItems" />
  </div>
</template>

<script>
import ScopeItemsList from "./ScopeItemsList";

export default {
  name: "ChangeOrderScopeItems",
  components: { ScopeItemsList },
  computed: {
    scopeItems() {
      let scopeItems = this.$store.state.Settings.changeOrderItems;
      if (scopeItems) {
        scopeItems.sort((a, b) => a.name.localeCompare(b.name));
      }

      return scopeItems;
    }
  },
  mounted() {
    if (this.scopeItems === null) {
      this.$store.dispatch("getAllScopeItems");
    }
  }
};
</script>

<style scoped></style>
